<template>
  <div class="v-container">
    <div class="v-page-header">小程序管理</div>
    <div class="v-header">
      <el-button @click="showAddEdit()" size="small" type="primary">新增小程序</el-button>
    </div>
    <div class="v-content" v-loading="loading">
      <el-table size="small" border :data="lists" height="100%">
        <el-table-column label="ID" width="50" prop="id" />
        <!--        <el-table-column label="入口背景图" width="150">-->
        <!--          <template slot-scope="scope">-->
        <!--            <img :src="scope.row.backend_image_preview" style="height: 40px;max-width: 100%;max-height: 100%;">-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column label="小程序名称" prop="name"></el-table-column>
        <el-table-column label="小程序简介" prop="describe"></el-table-column>
        <el-table-column label="APPID" prop="appid"></el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="showAddEdit(scope.row)" size="min" class="v-ml-5" type="warning">编辑</el-button>
            <el-popconfirm title="确认删除？" @onConfirm="doDelete(scope.row)">
              <el-button slot="reference" size="min" class="v-ml-5" type="danger" :loading="scope.row.deleteLoading">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <add-edit
      v-if="isShowAddEdit"
      :show.sync="isShowAddEdit"
      :row="row"
      @success="
        (page) => {
          getList(page);
        }
      "
    ></add-edit>
  </div>
</template>

<script>
import addEdit from './components/add-edit';

export default {
  components: { addEdit },

  data() {
    return {
      loading: false,
      lists: [],
      row: null,
      isShowAddEdit: false,
    };
  },
  mounted() {
    this.getList();
  },

  methods: {
    async getList() {
      this.loading = true;
      try {
        let res = await this.api.shop.lists();
        this.lists = res.data;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    showAddEdit(row) {
      this.row = row;
      this.isShowAddEdit = true;
    },

    //删除
    async doDelete(row) {
      this.$set(row, 'deleteLoading', true);
      try {
        await this.api.shop.delete({ id: row.id });
        this.$message.success('删除成功');
        this.getList();
      } catch (e) {
        console.error(e);
      }
      this.$set(row, 'deleteLoading', false);
    },
  },
};
</script>

<style scoped>
.v-header {
  display: flex;
  justify-content: flex-start;
}
</style>
